// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"W4-z"};